module.exports = __webpack_public_path__ + "img/plate_photo_7.e31dce58.jpg";